jQuery(document).ready(function ($) {
    let listicle_groups = $('.listicle-group__view-all-wrapper');
    
    // loop through all listicle groups and hide the border bottom of the last item
    for (let i = 0; i < listicle_groups.length; i++) {
        let listicle_group = $(listicle_groups[i]);
        listicle_group.prevAll('.listicle-item:first').css('border-bottom', 'none');
    }
});